import api from '../api';

export interface Setor {
    id: number;
    nome: string;
    empresa_id: number;
}

export class SetorService {
    /**
     * Busca um setor pelo nome e empresa_id, ou cria se não existir
     */
    static async findOrCreate(nome: string, empresaId: number): Promise<Setor> {
        try {
            const response = await api.post<Setor>('setores/find-or-create', {
                nome,
                empresa_id: empresaId,
            });
            return response.data;
        } catch (error: any) {
            throw new Error(error.response?.data?.message || 'Erro ao buscar/criar setor');
        }
    }
}
